import { createAction } from '@reduxjs/toolkit';

const actions = {
  nextWeek: createAction('calendar/NEXT_WEEK'),
  previousWeek: createAction('calendar/PREVIOUS_WEEK'),
  resetWeek: createAction('calendar/RESET_WEEK'),
};

export default actions;
